import { Plugins } from '@leverege/plugin';
import ValueThresholdizer from "./ValueThresholdizer.js";
import ValueThresholdizerEditor from "./ValueThresholdizerEditor.js";
export default {
  install(plg = Plugins) {
    plg.addPlugin('Model', {
      type: ValueThresholdizer.TYPE,
      model: ValueThresholdizer
    });
    plg.addPlugin('Thresholdizer', {
      type: ValueThresholdizer.TYPE,
      name: ValueThresholdizer.name,
      thresholdizer: ValueThresholdizer
    });
    plg.addPlugin('ModelEditor', {
      type: ValueThresholdizer.TYPE,
      editor: ValueThresholdizerEditor
    });
  }
};